import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { Router } from '@angular/router';
import { FirebaseService } from './shared/services/firebase.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(private firebaseService:FirebaseService, private router:Router) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    try {
      this.firebaseService.resetIdToken();
    } catch (error) {
      if(error){
        this.router.navigateByUrl("auth/login");
      }
    }
    const authToken = localStorage.getItem('matiSuperAdminToken');
    if (authToken && authToken != undefined) {
      // Clone the request and attach the token
      const authReq = req.clone({
        setHeaders: {
          Authorization: `Bearer ${authToken}`
        }
      });

      return next.handle(authReq);
    }

    // If there is no token, pass the original request
    return next.handle(req);
  }
}
